import AppCopy from "copy/AppCopy";

function StaffHeader() {
  const { emailText, nameText, phoneText, statusText } = AppCopy.staffPage;

  return (
    <div className={Classname.container}>
      <span className={Classname.phoneNo}>{phoneText}</span>
      <span className={Classname.fullName}>{nameText}</span>
      <span className={Classname.email}>{emailText}</span>
      <span className={Classname.status}>{statusText}</span>
    </div>
  );
}

export default StaffHeader;

const Classname = {
  container:
    "w-full border-b hidden sm:flex items-center justify-between text-sm text-secondaryText py-2",
  phoneNo: "w-1/5",
  fullName: "w-1/5",
  email: "w-1/5",
  status: "w-1/5",
};
